import React from "react";
import Pill from "../../ui/atoms/Pill";

/** Format scope type for display (e.g. "coaching_center" -> "Coaching center") */
function formatScopeTypeLabel(type: string): string {
  if (!type) return type;
  return type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** Sanitize type for CSS class (e.g. "coaching_center" -> "coaching-center") */
function toCssClass(type: string): string {
  return type.replace(/_/g, "-");
}

interface ScopeTypePillProps {
  /** Scope type from API (e.g. tournament, venue, coaching_center) */
  type: string;
  /** Optional custom label; defaults to formatted type */
  label?: string;
}

const ScopeTypePill: React.FC<ScopeTypePillProps> = ({ type, label }) => {
  const displayLabel = label ?? formatScopeTypeLabel(type);
  const cssClass = toCssClass(type);
  return (
    <Pill className={`scope-type-pill scope-type-pill--${cssClass}`}>
      {displayLabel}
    </Pill>
  );
};

export default ScopeTypePill;
